import * as React from 'react';
import { LineItem, LineItemMedia, LineItemContent, EyeSideIndicator } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import LineItemPrescription from '../../../components/LineItem/LineItemPrescription/LineItemPrescription.js';
import LineItemQuantity from '../../../components/LineItem/LineItemQuantity/LineItemQuantity.js';
import LineItemSubtitle from '../../../components/LineItem/LineItemSubtitle/LineItemSubtitle.js';
import LineItemTitle from '../../../components/LineItem/LineItemTitle/LineItemTitle.js';
import { getSubscriptionImageUrl } from '../../utils/get-subscription-image-url.js';

const getProductSubtitle = (product, intl)=>{
    if ('packageQuantity' in product) {
        const { packageQuantity , replacementFrequency  } = product;
        const frequencyLabelKey = intl.getLabel(`common.frequency.${replacementFrequency.toLowerCase()}`);
        // Todo: add eyeside in a later story
        return `${packageQuantity} ${frequencyLabelKey} ${intl.getLabel('products.unit.contactLenses')} ${intl.getLabel('products.perBox')}`;
    } else {
        return [
            product.brand,
            product.modelName
        ].filter(Boolean).join(' ');
    }
};
const CCCLineItem = ({ product , quantity , eyeSide  })=>{
    const variantInfo = product // Rename for clarity on what this actually is
    ;
    const intl = useIntl();
    const { brand  } = variantInfo;
    const subtitle = getProductSubtitle(variantInfo, intl);
    const imagePath = getSubscriptionImageUrl(variantInfo);
    /**
   * TODO: YB
   * Move to appropriate mapper when props of this component are simplified.
   */ const productQuantity = `${intl.getLabel('cart.item.quantity')}: ${quantity}`;
    const eyeSideElement = eyeSide && eyeSide !== 'both' ? /*#__PURE__*/ React.createElement(EyeSideIndicator, {
        className: "ccc-line-item__eyeside-indicator",
        side: eyeSide
    }) : null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "ccc-line-item",
        "data-t": "ccc-line-item"
    }, /*#__PURE__*/ React.createElement(LineItem, {
        className: "ccc-line-item__container"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        type: "image",
        imageUrl: imagePath,
        imageAlt: brand,
        overlayElement: eyeSideElement
    }), /*#__PURE__*/ React.createElement(LineItemContent, null, /*#__PURE__*/ React.createElement(LineItemTitle, {
        title: brand
    }), subtitle && /*#__PURE__*/ React.createElement(LineItemSubtitle, {
        subtitle: subtitle
    }), 'lensProperties' in variantInfo && /*#__PURE__*/ React.createElement(LineItemPrescription, {
        prescriptionAttrs: variantInfo.lensProperties
    }), /*#__PURE__*/ React.createElement(LineItemQuantity, {
        quantity: productQuantity
    }))));
};

export { CCCLineItem as default, getProductSubtitle };
//# sourceMappingURL=CCCLineItem.js.map
